/**
 * @volley/crucible-web — browser SPA entry.
 *
 * Cookie-mode boot path (the Bifrost #87 colocation deployment).
 * The actual root lives in `cloud-root.tsx` so tests can exercise
 * desktop-switch fallback behavior without triggering `createRoot`.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@volley/crucible-ui/styles/globals.css';

import { Root } from './cloud-root.js';
import { maybeInstallLocalCloudMock } from './dev/local-cloud-mock.js';

maybeInstallLocalCloudMock();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Foundry SPA bootstrap: #root not found in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
